import styled from "styled-components";

export const Container = styled.button`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 150px;

    padding: 10px;

    font-size: 16px;
    
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    color: ${(props) => props.theme.colors.gray.gray_200};

    &:hover{
        color: ${(props) => props.theme.colors.primary};
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }

    &.active {
        background-color: ${(props) => props.theme.colors.white};
        color: ${(props) => props.theme.colors.primary};
        box-shadow: 0px 2px 2px 0px rgb(0,0,0, .25);
    }
`;